import { ManagedLanguages } from "@monolith/legacy/types/global";
import { getInjectedContent } from "@modules/core/services/injected-content";
import { GlobalMetaTagName } from "@modules/core/services/initial-state";

export const getManagedLanguages = (): ManagedLanguages => {
  const languages = getInjectedContent<ManagedLanguages>(GlobalMetaTagName.ManagedLanguages);
  if (!languages) {
    throw new Error('Managed languages meta tag is missing or invalid');
  }
  return languages;
};
